import ResearchClinicFAQList from 'src/pages/ResearchClinicFAQ/ResearchClinicFAQList';

export const researchClinicFaqRoutes = [
  // research clinic faq
  {
    path: '/research-clinic/faq',
    component: ResearchClinicFAQList,
  },  
];
